import { LoadingSpinner } from "@/components";
import { useAuth } from "@/contexts/AuthContext";
import { PrivateRoutes, PublicRoutes } from "./components";

export default function ProxyRouter() {
  const { user, loading: isLoading } = useAuth();

  // Mostra loading enquanto verifica autenticação
  if (isLoading) {
    return <LoadingSpinner size="lg" />;
  }

  return user ? <PrivateRoutes /> : <PublicRoutes />;
}
